import script from "./ChatSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSetting.vue?vue&type=script&setup=true&lang=js"

import "./ChatSetting.vue?vue&type=style&index=0&id=c4ef5ba2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4ef5ba2"]])

export default __exports__